// extracted by mini-css-extract-plugin
export default {"gallery":"c-q_ga","gallery__header":"c-q_gb","gallery__thumbs":"c-q_gc"};